import { inject, Component } from '@angular/core';
import { EventsService } from '@services/events/events.service';
import { ScriptLoaderService } from '@services/script-loader/script-loader.service';

@Component({
  selector: 'app-verloop-chat',
  templateUrl: './verloop-chat.component.html',
  styleUrls: ['./verloop-chat.component.scss']
})
export class VerloopChatComponent {

  private events = inject(EventsService);
  private scripts = inject(ScriptLoaderService);

  isLoading;

  ngOnInit() {
    this.checkIfScriptLoaded();
  }

  async loadChatBox() {
    this.isLoading = true;
    try {
      await this.scripts.loadScript('verloop', '', true);
    } catch (error) {
      this.isLoading = false;
    }
  }
  async checkIfScriptLoaded() {
    try {
      await this.events.isScriptReady('verloop_loaded');
      if ((<any>window)?.Verloop) {
        this.isLoading = false;
        document.getElementById('verloopChatBox').style.display = 'none';
        (<any>window).Verloop.livechat.openWidget();
      }
    } catch (error) {
      this.isLoading = false;
    }
  }

}
